// src/App.js
import React from 'react';
import SolarSystem from './components/SolarSystem';

function App() {
  return (
    <div style={{ height: '100vh' }}>
      <SolarSystem />
    </div>
  );
}

export default App;
